var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "th",
    {
      staticClass: "admin-th-sort",
      class: {
        "is-active": _vm.isActive,
        "is-asc": _vm.isActive && _vm.order === "asc",
        "is-desc": _vm.isActive && _vm.order === "desc",
      },
      attrs: {
        role: "columnheader",
        scope: "col",
        "aria-sort": _vm.ariaSort,
        "aria-keyshortcuts": "Enter Space",
        tabindex: "0",
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onSort.apply(null, arguments)
        },
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
            return _vm.onSort.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            )
              return null
            $event.preventDefault()
            return _vm.onSort.apply(null, arguments)
          },
        ],
      },
    },
    [
      _c("span", { staticClass: "admin-th-sort__inner" }, [
        _c(
          "span",
          { staticClass: "admin-th-sort__label" },
          [_vm._t("default")],
          2
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "admin-th-sort__icons",
            attrs: { "aria-hidden": "true" },
          },
          [
            _c("admin-icon", {
              staticClass: "admin-th-sort__up",
              attrs: { name: "chevron-up" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-th-sort__down",
              attrs: { name: "chevron-down" },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }